
import { Link } from 'react-router-dom';

const products = [
  { id: 1, name: 'Classic Frame' },
  { id: 2, name: 'Modern Frame' }
];

function Products() {
  return (
    <div className="container">
      <h2>Eyeglasses</h2>
      <ul>
        {products.map(p => (
          <li key={p.id}>
            <Link to={`/products/${p.id}`}>{p.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Products;
